export var clientSearchMapper = function (data) {
    var result = [];
    if (data && data.length > 0) {
        result = data.map(function (item) {
            return {
                clientName: item.clientName,
                userName: item.userName,
                accountCode: item.accountCode,
                udnNo: item.udnno,
                leadId: item.leadid,
                pan: item.pan,
                priority: item.priority,
                msgFlag: item.msgFlag,
                accessMsg: item.accessMsg,
                mobileNo: item.mobileNo,
                email: item.email,
                isPartner: item.masterFlag === "PTR" ? true : false,
                uniqueCode: item.uniqueCode,
                isVerified: true,
            };
        });
    }
    return result;
};
